import React from 'react';


import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';



import './Recruit.css';



const Recruit = () => {




  return (
    <>
      <Navbar />
      <div className="hero-section">
        <h1>Hi!</h1>
        <h2>Looking for your next big thing?</h2>
        {/*<h3>Está atento às nossas redes sociais, terás novidades em breve</h3>*/}
        <a href="https://recrutamento.jeknowledge.pt/" target="_blank" rel="noreferrer">jeK is recruiting!</a>
      </div>
      {/*<section className="c-recruit">
      <ImageGallery
        items={images}
        showBullets={true}
        showThumbnails={false}
        loading={true}
        infinite={true}
        lazyLoad={true}
        showPlayButton={false}
        originalHeight={false}
      />
    </section>
    <CountDownTimer date="October 21, 2023 00:00:00" />*/}
      <Footer />
    </>
  )
}

export default Recruit;
